import React from "react";
import "./App.css";
import HomePage from "./components/pages/HomePage";
import AboutMe from "./components/pages/AboutMe";
import ExpAndEdu from "./components/pages/ExpAndEdu";
import Portfolio from "./components/pages/Portfolio";
import Contact from "./components/pages/Contact";
import Blogs from "./components/pages/Blogs";
import YouTubeFeed from "./util/YouTubeFeed";

function App() {
  return (
    <div className="bg-black text-white font-sans">
      {/* Home */}
      <HomePage />

      {/* About Me */}
      <AboutMe />

      {/* Experience & Education */}
      <ExpAndEdu />

      {/* Portfolio */}
      <Portfolio />
      
      {/* YouTube */}
      <YouTubeFeed />

      {/* Contact */}
      <Contact />

      {/* Blog */}
      <Blogs />
    </div>
  );
}

export default App;
